import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to the top of the page when navigating to a new route
 * Handles both window scroll and scrollable container elements
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      // Scroll window to top
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });

      // Also scroll any main content containers (for layouts with overflow containers)
      const mainElements = document.querySelectorAll('main');
      mainElements.forEach(main => {
        main.scrollTop = 0;
      });

      // Scroll any elements with overflow-y-auto class
      const scrollableElements = document.querySelectorAll('.overflow-y-auto');
      scrollableElements.forEach(element => {
        element.scrollTop = 0;
      });

      // Scroll mobile scroll content
      const mobileScrollElements = document.querySelectorAll('.mobile-scroll-content');
      mobileScrollElements.forEach(element => {
        element.scrollTop = 0;
      });
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
